module.exports = __webpack_public_path__ + "static/2_1_search-2_FR-60a031c049ebebd8bac31b37a47724e5.svg";